import { createSelector } from '@ngrx/store';
import { Actions, ActionTypesSpecialScenarios } from '@ordersnproducts/modules/shared/actions/special-scenarios.action';
export interface SpecialScenariosReducerState {
  specialScenarioActive?: string[];
}
export const initialState: SpecialScenariosReducerState = {
  specialScenarioActive: [],
};

export function specialScenariosReducer(state = initialState, action: Actions): SpecialScenariosReducerState {
  switch (action.type) {
    case ActionTypesSpecialScenarios.SAVE_SPECIAL_SCENARIOS_ACTIVE: {
      return { ...state, specialScenarioActive: action.payload };
    }
    case ActionTypesSpecialScenarios.REMOVE_SPECIAL_SCENARIOS_ACTIVE: {
      return { ...state, specialScenarioActive: state.specialScenarioActive.filter((item) => item !== action.payload) };
    }
    case ActionTypesSpecialScenarios.CLEAN_ALL_SPECIAL_SCENARIOS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export const getSpecialScenariosState = (state: any) => state.ordersAndProductsComponents.specialScenarios;

export const getSpecialScenariosActive = createSelector(
  getSpecialScenariosState,
  (state: SpecialScenariosReducerState) => (state ? state.specialScenarioActive : []),
);
